import * as React from "react";
// import CardActions from "@mui/material/CardActions";
import { CardMedia, CardContent, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Role_Responder_VideoType } from "../utils/types";
import { getBadgeClassname } from "../utils/getClassName";

import {
  parseDate,
  toHoursAndMinutes,
  convertDatetoTime,
} from "../utils/dateandtime";
import { fullOrientation } from "../utils/orientation";
import { getLocalStorageUser } from "../utils/getLocalStorageUser";
import "./style.css";

interface VideoCardProps {
  data: Role_Responder_VideoType;
  key: string;
  //   setVideoURL: Function;
  //   setIsModalOpen: Function;
  //   videoModalOpen: Function;
  //   UrlFunction: Function;
  //   setIsAuth2nd: Function;
  //   setCurrentVideoThumbnails: Function;
  //   isAuth2nd: {
  //     identity: string;
  //     sls: boolean;
  //     police: boolean;
  //     uts: boolean;
  //   };
  //   setProvider: Function;
}
export default function VideoCard(props: VideoCardProps) {
  const {
    data: {
      _id,
      address,
      date,
      insight,
      keywords,
      locality,
      name,
      postcode,
      provider,
      thumbnail,
      videoURL,
      camera,
      duration,
      orientation,
      location,
    },
    // setVideoURL,
    // setIsModalOpen,
    // UrlFunction,
    // videoModalOpen,
    // setIsAuth2nd,
    // isAuth2nd,
    // setCurrentVideoThumbnails,
    // setProvider,
  } = props;
  // React.useEffect(() => {
  //   UrlFunction(videoURL);
  // }, []);

  // const user = localStorage.getItem("user");
  // const objUser = JSON.parse(user);

  const navigate = useNavigate();
  const eventWork = async (e: any) => {
    console.log("get message333");
    console.log(e);
  };
  const user = getLocalStorageUser() || "responder";

  const cardClickHandler = (provider: string) => {
    // console.log("card clicked");
    // console.log("termsAgree", termsAgree);
    // setIdClicked(_id);
    // if (termsAgree[provider] !== true) {
    //   setIsTermsShow(true);
    // } else {
    if (user.role === "volunteer") {
      // videoModalOpen(true);
      // setCurrentVideoThumbnails(thumbnail);
      // setProvider(provider);
    } else {
      window.open(`/video/${_id}`, "_blank");
    }
    // }
  };

  function IconHandleClick() {
    // window.open(
    //   get2ndAuthUrl(provider),
    //   "_blank" // <- This is what makes it open in a new window.
    // );
    // // window.location.reload();
    // navigate("/video");
    // window.location.reload();
  }
  // const duration2 = 0;

  return (
    <Card
      sx={{
        width: "300px",
        margin: "10px 10px",
        // backgroundColor: "lightgrey",
        position: "relative",
        ":hover": {
          boxShadow:
            "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
          cursor: "pointer",
        },
      }}
    >
      <CardMedia
        sx={{ height: 140 }}
        image={thumbnail[0]}
        title="green iguana"
        onClick={() => cardClickHandler(provider)}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          // background: "yellow",
          height: "25px",
          marginTop: "-28px",
        }}
      >
        {duration && (
          <div
            style={{
              marginLeft: "4px",
              background: "black",
              color: "white",
              minWidth: "35px",
              maxWidth: "40px",
              textAlign: "center",
              borderRadius: "10px",
              padding: "1px 6px",
              lineHeight: "25px",
            }}
          >
            <div>{duration && toHoursAndMinutes(duration)}</div>
          </div>
        )}
      </div>
      <CardContent
        sx={{
          position: "relative",
          padding: "10px 15px",
          paddingBottom: "0px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            height: "40px",
          }}
        >
          <div
            style={{
              height: "40px",
              borderRadius: "20px",
              textAlign: "center",
              lineHeight: "40px",
              fontSize: "20px",
              fontWeight: "500",
            }}
          >
            {name.toUpperCase()}
          </div>

          <div
            style={{ fontSize: "16px", padding: "8px" }}
            className={getBadgeClassname(provider)}
          >
            {provider.toUpperCase()}
          </div>
        </div>
        <p
          className="videoCard_insight"
          style={{ fontWeight: "700", fontSize: "17px" }}
        >
          {insight ? insight : "Insignt here"}
        </p>

        <p style={{ marginBottom: "0px", fontSize: "15px" }}>
          <span>
            {date && user.role === "responder"
              ? parseDate(date) + " , " + convertDatetoTime(date)
              : parseDate(date)}
          </span>
        </p>
        <p style={{ marginBottom: "0px", fontSize: "15px" }}>
          <span>{locality}</span>
          <span> • </span>
          <span>{postcode}</span>
        </p>
        {user.role === "responder" && address && (
          <p
            style={{ marginBottom: "0px", fontSize: "15px" }}
            className="longtext_hidden"
          >
            <span>{address}</span>
          </p>
        )}
        {orientation && (
          <p style={{ marginBottom: "0px", fontSize: "15px" }}>
            <span>Camera direction: {fullOrientation(orientation)}</span>
          </p>
        )}
      </CardContent>
    </Card>
  );
}
